import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SingleSectionComponent from 'components/SingleSectionComponent/SingleSectionComponent';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';

export default function CurricularAdaptation({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [useAllactivities, setUseAllActivities] = useState();

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;
      const curricularAdaptationActivities = await assignValueById(activities, 6);
      if (curricularAdaptationActivities.length === 0) {
        setUseAllActivities(null);
      } else {
        setUseAllActivities({
          curricularAdaptationActivities,
        });
      }
    };

    loadActivities();
  }, [activities]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!useAllactivities) {
    return <>{' '}</>;
  }

  return (
    <div>
      <ProfileSection
        title="Adaptación Curricular"
        subtitleLyrics={{
          subtitle: '',
          lyrics: '',
        }}
      >
        <div>
          <SingleSectionComponent
            arrayOfPropertys={useAllactivities.curricularAdaptationActivities}
          />
        </div>
      </ProfileSection>
    </div>
  );
}

CurricularAdaptation.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
